import { render, staticRenderFns } from "./SelectColumnsImportContactToCampaign.vue?vue&type=template&id=ef19bfda&scoped=true"
import script from "./SelectColumnsImportContactToCampaign.vue?vue&type=script&lang=js"
export * from "./SelectColumnsImportContactToCampaign.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SelectColumnsImportContactToCampaign.vue?vue&type=style&index=1&id=ef19bfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef19bfda",
  null
  
)

export default component.exports